import React from 'react'
// eslint-disable-next-line react/prop-types
const ClearSVG =({className, onClick}) =>



<svg className={className} onClick={onClick} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="10" cy="10" r="10" fill="#EEEEF0"/>
<path d="M11.0213 10L14 7.02128L12.9787 6L10 8.97872L7.10638 6L6 7.10639L8.97872 10L6 12.9787L7.02128 14L10 11.0213L12.9787 14L14 12.9787L11.0213 10Z" fill="#3C3738"/>
</svg>


export default ClearSVG
